// src/components/studio/steps/Step4Gift.tsx
import { motion } from "framer-motion";
import BouquetCustomizer from "../../bouquet/BouquetCustomizer";
import { tiktokPixelService } from "../../../services/tiktok-pixel.service";

interface Step4GiftProps {
  customization: any;
  setCustomization: (c: any) => void;
  validation: any;
}

export default function Step4Gift({ customization, setCustomization }: Step4GiftProps) {
  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-5">
      <BouquetCustomizer
        amount={customization.includeBouquet ? customization.bouquetAmount : 0}
        onAmountChange={(amount) => {
          setCustomization({
            ...customization,
            bouquetAmount: amount,
            includeBouquet: amount > 0,
          });

          if (amount > 0) {
            tiktokPixelService.trackAddToCart(
              {
                content_id: "digital_bouquet",
                content_type: "product",
                content_name: "Digital Bouquet",
              },
              amount,
              "KES",
              `addtocart:bouquet:${amount}`
            );
          }
        }}
        enabled={customization.includeBouquet}
        onEnabledChange={(enabled) =>
          setCustomization({
            ...customization,
            includeBouquet: enabled,
            bouquetAmount: enabled ? customization.bouquetAmount || 1000 : 0, // Set default 1000 when enabling
          })
        }
      />
    </motion.div>
  );
}
